import {
  normalizeQuantityOptions,
  createQuantityOptions,
  QuantityOption,
} from "../../../domain/policies/quantityPolicy";

import { IFlagsmithFeature } from "flagsmith/types";

export class GetQuantityOptionsUseCase {
  constructor(private readonly flags: IFlagsmithFeature) {}

  execute(): QuantityOption[] {
    const raw = this?.flags?.value;

    const fromFlag = normalizeQuantityOptions(raw, {
      includeZero: false,
    });
    if (fromFlag && fromFlag.length > 0) return fromFlag;

    return createQuantityOptions({
      max: 20,
      includeZero: false,
      unitLabel: (n) => `${n}.000`,
    });
  }
}
